import { render } from "./RMUploadDialog.vue?vue&type=template&id=b87c427e&scoped=true"
import script from "./RMUploadDialog.vue?vue&type=script&lang=js"
export * from "./RMUploadDialog.vue?vue&type=script&lang=js"

import "./RMUploadDialog.vue?vue&type=style&index=0&id=b87c427e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87c427e"]])

export default __exports__